import { api } from '../../../../../api/common/instances';
import bus from '../../../../../utils/bus';
import validation from '../../../../../utils/validation';

const defaultItem = {};

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      item: defaultItem,
      systemIds: [],
      valid: true,
      disabledSave: true,
      rules: {
        ...validation,
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    disabledRegister() {
      return !this.valid;
    },
  },
  watch: {
    show: {
      immediate: true,
      handler: 'setDialogActivated',
    },
  },
  methods: {
    async register(type) {
      // const query = Object.entries(this.item).map(e => e.join('=')).join('&'); // eslint-disable-line
      const query = new URLSearchParams(this.item).toString();
      const { status, data } = await api.get(`/preference/system/${type}?${query}`);
      if (status == 200) {
        const system = data;
        if (this.systemIds.some(id => id == system.id)) {
          this.$dialog.alert(this.$t('validation.registered'));
        } else {
          bus.$emit('insert-data', system);
          this.show = false;
        }
      } else {
        this.$dialog.alert(data.message);
      }
    },
    cancel() {
      this.show = false;
      this.$refs.form.reset();
    },
    setDialogActivated(show) {
      if (show) {
        this.onShow();
        this.addEvent();
        bus.$emit('req-system-ids');
        this.disabledSave = true;
      } else {
        this.removeEvent();
        this.$refs.form.resetValidation();
      }
    },
    addEvent() {
      bus.$on('res-system-ids', systemIds => (this.systemIds = systemIds));
    },
    removeEvent() {
      bus.$off('res-system-ids');
    },
    setDisabledSave() {
      this.disabledSave = !this.valid;
    },
    onShow() {},
  },
};
